import { useState } from 'react';
import { useSearchParams } from 'react-router';
import { useTranslation } from 'react-i18next';
import { Plus, UserPlus } from 'lucide-react';
import { Abas, PainelAba } from '../../componentes/abas';
import { AcaoPrimaria } from '../../componentes/acao-primaria';
import { Botao } from '../../componentes/base';
import { useSessao } from '../../nucleo/sessao';
import { useIcones } from '../../nucleo/icones-navegacao';
import { ConviteModal, Convites } from './Convites';
import { Membros } from './Membros';
import { Papeis } from './Papeis';
import { Pedidos } from './Pedidos';

type Sub = 'membros' | 'convites' | 'papeis' | 'pedidos';
/** Sub-abas internas de Usuários e papéis (também no mapa de caminhos, `nucleo/caminhos.ts`). */
export const SUBS: Sub[] = ['membros', 'convites', 'papeis', 'pedidos'];

/** M12.4: membros, convites pendentes e papéis, numa só aba com sub-navegação local. */
export function Usuarios() {
  const { t } = useTranslation('admin');
  // D2: ícones nas sub-abas (ligados por padrão; só o desligar explícito do workspace tira).
  const icones = useIcones();
  const s = useSessao();
  // Lista de 30/10 (item 11): o aviso de pedido novo abre direto na fila (`?sub=pedidos`).
  const [params] = useSearchParams();
  const [sub, setSub] = useState<Sub>(() => (SUBS.includes(params.get('sub') as Sub) ? (params.get('sub') as Sub) : 'membros'));
  const [convidar, setConvidar] = useState(false);
  const [novoPapel, setNovoPapel] = useState(false);
  return (
    <div className="flex min-w-0 flex-col gap-4">
      <AcaoPrimaria>
        {(sub === 'membros' || sub === 'convites') && s.pode('admin.usuarios') && (
          <Botao variante="primario" icone={<UserPlus className="size-4" />} onClick={() => setConvidar(true)}>
            {t('usuarios.convidar')}
          </Botao>
        )}
        {sub === 'papeis' && s.pode('admin.papeis') && (
          <Botao variante="primario" icone={<Plus className="size-4" />} onClick={() => setNovoPapel(true)}>
            {t('usuarios.novoPapel')}
          </Botao>
        )}
      </AcaoPrimaria>

      <Abas idBase="usuarios-subabas" rotulo={t('abas.usuarios')} ativa={sub} aoMudar={setSub} itens={SUBS.map((k) => ({ chave: k, rotulo: t(`usuarios.subabas.${k}`), icone: icones.de(`usuarios.${k}`) }))} />

      <PainelAba idBase="usuarios-subabas" chave={sub} className="min-w-0">
        {sub === 'membros' && <Membros />}
        {sub === 'convites' && <Convites />}
        {sub === 'papeis' && <Papeis criando={novoPapel} aoFecharCriar={() => setNovoPapel(false)} />}
        {sub === 'pedidos' && <Pedidos />}
      </PainelAba>
      <ConviteModal aberto={convidar} aoFechar={() => setConvidar(false)} />
    </div>
  );
}
